import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { License } from '../models/license-details'

@Injectable()
export class LicenseDataService {
    licensedata = {} as License
    private messageDataSource = new BehaviorSubject(this.licensedata)
    data = this.messageDataSource.asObservable()

    constructor() {}

    sendData(data: License) {
        this.messageDataSource.next(data)
    }
}
